// import Simmer from 'simmerjs'
import unique from 'unique-selector'

// const simmer = new Simmer(window)

export default target => {
  // check if drop target is an svg
  // climb back out if it is

  // const selectorSimmer = simmer(target)
  // const selectorSelectorartor = $(target).getSelector()
  const selectorUnique = unique(target)

  // console.log('____SECTOR FACEOFF____')
  // console.log('Simmer:', selectorSimmer)
  // console.log('Selectorator:', selectorSelectorartor)
  console.log('unqiue:', selectorUnique)

  return selectorUnique
}
